export const LOGO_LENGTH = 48;

export * from './sendingPlatforms';
export * from './serviceProviders';
export * from './metadata';
export * from './text';
